import { defineStore } from 'pinia';
import {
  ref,
  type Ref,
} from 'vue';
import { invalidateBankId } from '@/services/bankId.service';


export const useSwedishProfileStore = defineStore('SwedishProfile', () => {
  const isBankIdFlow: Ref<boolean> = ref(false);
  const bankIdFlowCancelled: Ref<boolean> = ref(false);

  function setRegisteredThroughBankId(): void {
    isBankIdFlow.value = true;
    bankIdFlowCancelled.value = false;
  }

  async function setBankIdFlowCancelled(): Promise<void> {
    // call to let BE know user cancelled, so they don't store creditsafe data
    await invalidateBankId();
    bankIdFlowCancelled.value = true;
    isBankIdFlow.value = false;
  }

  function isBankIdFlowCancelled(): boolean {
    return bankIdFlowCancelled.value;
  }

  function isRegisteredThroughBankId(): boolean {
    return isBankIdFlow.value;
  }

  return { setRegisteredThroughBankId, isRegisteredThroughBankId, setBankIdFlowCancelled, isBankIdFlowCancelled };
});
